import React, { useEffect, useMemo, useState } from 'react'
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from '../../components'
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from '../../components/NextUITable'
import { usePost } from '../../api/reactQueryCustomHooks'
import { apiRoute, GetLoginCredentialDb, linksUrl } from '../../constants/enum'
import { faEdit, faPlus, faReceipt, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import { Button, Modal, ModalBody, ModalHeader, ModalContent, useDisclosure } from '@nextui-org/react'
import { useDispatch, useSelector } from 'react-redux'
import ConfirmBox from '../../components/ConfirmBox'
import { toast } from 'react-toastify'
import { resetDetailParams, setDetailParams, setNewEntry } from '../../state/salesOrderEntrySlice'


const SalesOrderMaster = () => {
    const {
        isOpen: isOpenModel,
        onOpen: onOpenModel,
        onOpenChange: onOpenModelChange
    } = useDisclosure()

    const { token, user } = useSelector((state) => state.auth)
    const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [itemToDelete, setItemToDelete] = useState("")
    const INITIAL_VISIBLE_COLUMNS = ["actions", "PartyName", "Ord_No", "Ord_Date"]
    // const [data, setData] = useState([])



    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        dispatch(resetDetailParams())
    }, [])

    const { isPending, isError,
        //  data: EntryData = [],
        data = [],
        mutate: filterData } = usePost({
            url: apiRoute.transaction.salesOrderEntry.fetchOrder,
            queryKey: "Sales Order Data"
        })
    const exportColumns = [

        {
            name: "Party Name",
            uid: "PartyName",
        },
        {
            name: "Order No",
            uid: "Ord_No",
        },

        {
            name: "Ord.Date",
            uid: "Ord_Date",
            type: COLUMN_TYPE.date
        }
    ]
    // const totalRecAmt = useMemo(
    //     () =>
    //         calculateTotal({
    //             data: data,
    //             columnName: "Chq_Amt",
    //         }),
    //     [data])


    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center
        },

        {
            name: "Party Name",
            uid: "PartyName",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },

        {
            name: "Order No",
            uid: "Ord_No",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true
        },

        {
            name: "Ord.Date",
            uid: "Ord_Date",
            align: COLUMN_ALIGN_TYPE.center,
            type: COLUMN_TYPE.date,
            sortable: true
        },
    ]



    const funLoadData = () => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                bill_type: "S",
            }
        })
    }
    //console.log(data)
    useEffect(() => {
        funLoadData()
    }, [])

    const reportModel = () => {
        return (
            <Modal
                isOpen={isOpenModel}
                onOpenChange={onOpenModelChange}
                size="md">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-row gap-1">
                                Voucher
                            </ModalHeader>
                            <ModalBody>
                                <div className="flex flex-col">

                                </div>
                            </ModalBody>
                        </>

                    )}
                </ModalContent>
            </Modal>
        )
    }

    let downloadDataFooter = {
        PartyName: "", Order_No: "",
        Ord_Date: " ",
    }
    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                let obj = {
                    compcode: String(row.CompCode),
                    orderno: row.Ord_No,
                    billtype: row.Bill_Type,
                }

                dispatch(setDetailParams(obj))
                dispatch(setNewEntry(false))
                navigate(linksUrl.transaction.salesOrderEntry.createOrderEntry)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToDelete({ order_no: row.Ord_No, comp_code: row.CompCode, bill_type: row.Bill_Type })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        // {
        //     icon: <FontAwesomeIcon color="#075985" icon={faReceipt} />,
        //     onClick: (row) => {
        //         onOpenModel()
        //     },
        //     type: ROW_ACTION_BTN_TYPE.link,
        // },

    ]
    const onSuccessDelete = (data) => {
        setItemToDelete("")
        toast.success("Entry Deleted",
            { position: "top-center" })
        funLoadData();

    }
    const { mutate: FnDeleteEntry } = usePost({
        url: apiRoute.transaction.salesOrderEntry.deleteEntry,
        queryKey: "DeleteSalesOrderEntry",
        onSuccessTasks: onSuccessDelete,

    })

    const handleConfirmBox = (data) => {
        if (data) {
            FnDeleteEntry({
                data: {
                    comp_code: itemToDelete.comp_code,
                    order_no: itemToDelete.order_no,
                    bill_type: itemToDelete.bill_type
                }
            })
        }
    }

    const handleAddNew = () => {
        dispatch(resetDetailParams())
        navigate(linksUrl.transaction.salesOrderEntry.createOrderEntry)
    }
    if (isPending) {
        return <LoadingCard />
    }
    if (isError) {
        return <ErrorCard />
    }
    return (
        <div>
            {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}
            <MainContainer pageName='Sales Order Entry' breadcrumbs={["Master", "Sales Order Entry"]} >
                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                {reportModel()}
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    exportColumns={exportColumns}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadDataFooter={downloadDataFooter}
                    showAdvanceFilter={false}
                    downloadFileName='SalesOrder-list'
                    id="Ord_No"
                >
                </NextUITable>
            </MainContainer>
        </div>
    )
}

export default SalesOrderMaster